<!-- 커스텀 시도 추가/수정 -->
<template>
  <div>
    <div class="title-style">전체 카테고리 목록</div>

    <div class="desc-style">
      <div>* 카테고리를 삭제하면 복구가 불가능합니다.</div>
      <div>* 카테고리 추가 후 저장하기를 눌러주세요.</div>
    </div>

    <div class="category-box">
      <draggable class="list-group" v-model="category_list" @change="changeDraggable" handle=".cat-item">
        <div v-for="(item,idx) in category_list" :key="'category item'+idx"
          class="item-style flex-between" style="margin-bottom:12px">
          <div class="flex-align">
            <i class="material-icons lp-drag-indicator cat-item" style="margin-right:8px;">
              drag_indicator
            </i>
            <input v-if="item.state" type="text"
                   v-model="value" @input="e => value = e.target.value">
            <div v-else>{{ item.name }}</div>
          </div>
          <div>
            <button class="button half is-font" style="margin-right:4px"
              @click="editItem(item)" :style="btnStyle(item)">{{ item.state ? '저장' : '수정' }}</button>
            <button class="button half is-danger" @click="deleteItem(idx)">{{ item.state ? '취소' : '삭제' }}</button>
          </div>
        </div>
      </draggable>
    </div>

    <div class="item-style unselect" style="text-align:center;margin-bottom:20px"
      @click="addCategory">+ 새 카테고리 추가</div>

    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable
    },
    props: {
      list: {
        type: Array,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        value: '',
        category_list: []
      }
    },
    created(){
      this.category_list = this.list;
    },
    watch:{
      list() {
        this.category_list = this.list;
      }
    },
    methods: {
      changeDraggable() {
        this.$emit('update:list', this.category_list)
      },
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      saveData() {
        if(this.category_list.every(item => !item.state)) {
          this.$emit('update:category', this.category_list);
        }
        else {
          this.toast('모든 카테고리를 저장해주세요.')
        }
      },
      addCategory() {
        if(this.type==='product') {
          this.category_list.push({name: '카테고리', state: false, product_list: [], products: []});
        }
        else if(this.type==='partner') {
          this.category_list.push({name: '카테고리', state: false, partner_list: [], partners: []});
        }
        this.$emit('update:list', this.category_list);
        this.toast('새 카테고리를 추가했습니다.')
      },
      deleteItem(idx) {
        if(this.category_list[idx].state) {
          this.category_list[idx].state = false;
        } else {
          this.category_list.splice(idx,1);
          this.toast('카테고리가 삭제되었습니다.')
        }
      },
      editItem(item) {
        if(item.state) {
          item.name = this.value;
          item.state = false;
        }
        else {
          this.value = item.name;
          item.state = true;
        }
      },
      btnStyle(item) {
        let deco = {};

        if(item.state) {
          deco.border = '1px solid #FF5722';
          deco.color = '#FF5722';
        }
        else {
          deco.border = '1px solid #CCCCCC';
          deco.color = '#363636';
        }

        return deco;
      }
    }
  }
</script>
<style lang="stylus" scoped>
#header #body
#header #bottom
  padding 24px

input
  border 1px solid #CCCCCC
  padding 6px
  border-radius 4px
  font-size 16px

input:read-only
textarea:read-only
  background-color white
  border 0
  cursor default
  font-size 16px

.title-style
  color #000
  font-size 20px
  font-weight 400
  margin-bottom 12px

.desc-style
  color #989898
  font-size 13px
  font-weight 400
  margin-bottom 24px

.category-box
  height calc(80vh - 240px)
  overflow auto
  margin-bottom 30px

.item-style
  font-size 16px
  padding 14px 18px
  border 1px solid #ccc
  color #000


</style>
